<template>
    <Menu v-bind="$attrs">
        <Item name="Preview" icon="sr-2 sr-v2-person" linkUrl="/preview" :isActive="true" />

        <Group name="Edit" icon="sr-2 sr-v2-pencil" linkUrl="/athlete_profile">
            <Item name="My Family" linkUrl="/athlete_profile/account_contacts" />
            <Item name="Essentials" linkUrl="/athlete_profile" />
            <Item name="Athletic" linkUrl="/athlete_profile/athletic" />
            <Item name="Academic" linkUrl="/athlete_profile/academic" />
            <Item name="Commitment" linkUrl="/athlete_profile/commitment" />
        </Group>
    </Menu>
</template>

<script>
import Menu from '@/components/Navbar/SideMenu/Menu'
import Group from '@/components/Navbar/SideMenu/Group'
import Item from '@/components/Navbar/SideMenu/Item'
import { mapGetters } from 'vuex'

export default {
    components: {
        Menu,
        Group,
        Item,
    },
}
</script>
